import { App } from 'vue'

import Sidebar from './Sidebar.vue'
import CabinetHeader from './CabinetHeader.vue'
const register = (app: App<Element>): void => {
  app
  .component('Sidebar', Sidebar)
  .component('CabinetHeader', CabinetHeader)
}

export default {
  register,
}
